export const MENU_KEYS = {
  PSMS: 'psms',
};

export const SESSION_KEYS = {
  IS_PSMS_TIN_ASSOCIATED: 'isPSMSTinAssociated',
  PSMS_FEATURE_FLAG: 'psmsFeatureFlag',
};

export const FEATURE_FLAG_NAMES = {
  PSMS: 'PSMS',
};

export const ENV_FEATURE_KEYS = {
  PROVIDER_PERFORMANCE_TIN_WORKFLOW: 'PROVIDER_PERFORMANCE_TIN_WORKFLOW',
  CONTRACT_ID_SEARCH: 'CONTRACT_ID_SEARCH',
};

// Toggle between the new PEM page and the legacy Provider Experience page.
// true  -> new PEM page enabled, legacy Provider Experience disabled.
// false -> legacy Provider Experience enabled, new PEM page disabled.
export const PEM_FEATURE_ENABLED = false;
export const CRO_FEATURE_ENABLED = true; // Contract Remediation Opportunities (CRO) feature flag. Set to true to enable the feature, false to disable it.

// Selects which bulk Health System Details endpoint the View Tax ID Details page uses.
// true  -> /saved-tins-health-system-jobs/health-system-details (job id + polling)
// false -> /saved-tins-bulk-process/health-system-details (direct response)
export const HEALTH_SYSTEM_DETAILS_BULK_POLLING_ENABLED = false;
